var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Checkbox, Dimmer, Divider, Form, Icon, Loader, Message, Table } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { postJsonWithAuthn } from "../RequestHelpers";
import { FulfillmentUnit, KitDisplayModal, shipmentsForUnit, unitIsComplete, visitUnitsWithCorrespondingKitComponents } from "./SingleOrderPage";
var AddShipmentModal = /** @class */ (function (_super) {
    __extends(AddShipmentModal, _super);
    function AddShipmentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.tableRow = function (order, lastVersion, unit, itemIndex) {
            // JS sets are super dumb; can't control equality / hashcode used, so have to use primitives
            var serializedUnit = unit.serialize();
            var includeCallback = function (_, data) {
                _this.setState(function (oldState) {
                    var included = new Set(oldState.serializedFulfillmentUnitsToInclude);
                    if (data.checked) {
                        included.add(serializedUnit);
                    }
                    else {
                        included.delete(serializedUnit);
                    }
                    // clear completed as well
                    var completed = new Set(oldState.serializedFulfillmentUnitsToMarkComplete);
                    completed.delete(serializedUnit);
                    return {
                        serializedFulfillmentUnitsToInclude: included,
                        serializedFulfillmentUnitsToMarkComplete: completed
                    };
                });
            };
            var completeCallback = function (_, data) {
                _this.setState(function (oldState) {
                    var completed = new Set(oldState.serializedFulfillmentUnitsToMarkComplete);
                    if (data.checked) {
                        completed.add(serializedUnit);
                    }
                    else {
                        completed.delete(serializedUnit);
                    }
                    return {
                        serializedFulfillmentUnitsToMarkComplete: completed
                    };
                });
            };
            var unitIncluded = _this.state.serializedFulfillmentUnitsToInclude.has(serializedUnit);
            var unitCompleted = _this.state.serializedFulfillmentUnitsToMarkComplete.has(serializedUnit);
            return React.createElement(Table.Row, { title: "Item id: " + unit.itemId, key: itemIndex + "-" + unit.componentType },
                React.createElement(Table.Cell, null,
                    "Kit #",
                    itemIndex + 1,
                    " ",
                    React.createElement(KitDisplayModal, { admin: true, itemIndex: itemIndex, pricedKit: lastVersion.pricedKit, trigger: React.createElement(Button, { icon: 'eye', size: 'mini' }) })),
                React.createElement(Table.Cell, null, unit.componentType),
                React.createElement(Table.Cell, null, shipmentsForUnit(_this.props.order, unit).length),
                React.createElement(Table.Cell, null, unitIsComplete(_this.props.order, unit) ? React.createElement(Icon, { name: 'check' }) : ''),
                React.createElement(Table.Cell, null,
                    React.createElement(Checkbox, { onChange: includeCallback, checked: unitIncluded })),
                React.createElement(Table.Cell, null,
                    React.createElement(Checkbox, { disabled: !unitIncluded, onChange: completeCallback, checked: unitCompleted })));
        };
        _this.includeAll = function () {
            var serializedUnits = visitUnitsWithCorrespondingKitComponents(_this.props.order, function (order, lastVersion, unit) {
                return unit.serialize();
            });
            _this.setState({
                serializedFulfillmentUnitsToInclude: new Set(serializedUnits)
            });
        };
        _this.completeIncluded = function () {
            _this.setState(function (oldState) { return ({
                serializedFulfillmentUnitsToMarkComplete: new Set(oldState.serializedFulfillmentUnitsToInclude)
            }); });
        };
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
            }, function () {
                postJsonWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.order.id) + "/shipments", JSON.stringify({
                    shipmentContents: Array.from(_this.state.serializedFulfillmentUnitsToInclude)
                        .map(function (serialized) {
                        var deserialized = FulfillmentUnit.deserialize(serialized);
                        return {
                            fulfillmentUnit: {
                                itemId: deserialized.itemId,
                                componentType: deserialized.componentType
                            },
                            completesUnit: _this.state.serializedFulfillmentUnitsToMarkComplete.has(serialized)
                        };
                    }),
                }))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true,
                            errors: []
                        });
                        return;
                    }
                    else if (resp.status === 400) {
                        return resp.json();
                    }
                    else {
                        _this.setState({
                            loading: false,
                            success: false,
                            errors: [{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }]
                        });
                        return;
                    }
                })
                    .then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            errors: resp.errors,
                            loading: false,
                            success: false
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't add shipment: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            serializedFulfillmentUnitsToInclude: new Set(),
            serializedFulfillmentUnitsToMarkComplete: new Set(),
        };
        return _this;
    }
    AddShipmentModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/fulfillmentUnits', labelContent: React.createElement(React.Fragment, null, "Fulfillment units to include") },
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Kit"),
                            React.createElement(Table.HeaderCell, null, "Component"),
                            React.createElement(Table.HeaderCell, null, "Shipments"),
                            React.createElement(Table.HeaderCell, null, "Completed already"),
                            React.createElement(Table.HeaderCell, null, "Include?"),
                            React.createElement(Table.HeaderCell, null, "Mark as complete?"))),
                    React.createElement(Table.Body, null, visitUnitsWithCorrespondingKitComponents(this.props.order, this.tableRow)))),
            React.createElement(Button, { icon: 'check', label: 'Include all', labelPosition: 'left', onClick: this.includeAll }),
            React.createElement(Button, { disabled: this.state.serializedFulfillmentUnitsToInclude.size === 0, icon: 'check', label: 'Complete included', labelPosition: 'left', onClick: this.completeIncluded }),
            React.createElement(Divider, null),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Shipment added."),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            React.createElement(Button, { disabled: this.state.success || this.state.serializedFulfillmentUnitsToInclude.size === 0, icon: 'box', label: 'Add shipment', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return AddShipmentModal;
}(React.PureComponent));
export default AddShipmentModal;
;
//# sourceMappingURL=AddOrderShipment.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddOrderShipment.js
// module id = 1098
// module chunks = 0